import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { Subject } from 'rxjs';

import { UserProfileTab } from '@core/tellent-types';
import { parametrizedRoutePath, tellentRouteFactory } from '@core/tellent-util';

import { withCurrentUserProfileDialogOpener } from './current-user-profile-dialog-opener';

export const TELLENT_PROFILE_DIALOG_QUERY_PARAM = `ts-profile-dialog`;
export const TELLENT_PROFILE_DIALOG_ID = 'client:profile_dialog';

export const currentUserProfileTellentClientRoute = () => {
  const router = inject(Router);
  const profileDialogCloseNotif = new Subject();
  const openProfileDialog = withCurrentUserProfileDialogOpener(profileDialogCloseNotif);

  return tellentRouteFactory(
    TELLENT_PROFILE_DIALOG_ID,
    parametrizedRoutePath(`?${TELLENT_PROFILE_DIALOG_QUERY_PARAM}=:tab,:analyticsContext`),
    {
      handler: {
        trigger: (location: string, cleanupFn) => {
          const tree = router.parseUrl(location);
          const params = <`${UserProfileTab},${string}`>(
            tree.queryParamMap.get(TELLENT_PROFILE_DIALOG_QUERY_PARAM)
          );

          const [tab, context] = params.split(',');

          const ref = openProfileDialog(context, <UserProfileTab>(tab ?? UserProfileTab.Profile));

          ref.afterClosed.subscribe(() => {
            delete tree.queryParams[TELLENT_PROFILE_DIALOG_QUERY_PARAM];
            cleanupFn(tree.toString());
          });

          return ref;
        },
        dispose: ref => ref.close(),
      },
      matchPath: location => location.includes(`${TELLENT_PROFILE_DIALOG_QUERY_PARAM}=`),
    },
  );
};
